<template>
    <b-modal
      id="desativar-aviso-modal"
      size="sm"
      button-size="sm"
      centered
      header-bg-variant="secondary"
      header-text-variant="light"
      header-class=""
      footer-class=""
      modal-class="p-2"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header="">
        <h5>Desativar aviso</h5>
      </template>
      Tem certeza que deseja desativar o aviso?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="desativarAviso()">
          Sim, desativar
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalDesativarAviso()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
</template>

<script>
import messagesService from "@/services/messagesService"

export default {
    name: "modal-desativar-aviso",
    props: ["idAviso"],
    methods: {
        fecharModalDesativarAviso() {
          this.$bvModal.hide('desativar-aviso-modal')
          this.$emit("fecharModalDesativarAviso")
        },

        async desativarAviso() {
          const response = await messagesService.inativarAviso(this.idAviso)
          if(response && response.status === 200) {
            this.fecharModalDesativarAviso()
            this.$toast.success("Aviso desativado com sucesso")
          }
          else {
            this.$toast.error("Erro ao desativar o aviso")
          }
        },
    },

    async mounted() {
        this.$bvModal.show("desativar-aviso-modal");
    }
}
</script>

<style>
#input-group-filtroUg .multiselect__option--selected {
    color: #fff !important;
    background: #a2a9af  !important;
    font-weight: 400;
}
</style>